/*
 * Copyright (C) 2022 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Directive, TemplateRef } from '@angular/core';

export class ResponsivePillContext {
  public readonly collapsed: boolean;
  public readonly shadow: boolean;

  constructor(config: { collapsed: boolean; shadow?: boolean }) {
    this.collapsed = config.collapsed;
    this.shadow = config.shadow ?? false;
  }

  get displayed(): boolean {
    return !this.collapsed;
  }
}

@Directive({
    selector: '[ngfResponsivePill]',
    standalone: false
})
export class ResponsivePillDirective {

  constructor(public readonly templateRef: TemplateRef<ResponsivePillContext>) {}

  static ngTemplateContextGuard(dir: ResponsivePillDirective, ctx: unknown):
    ctx is ResponsivePillContext {
    return true;
  }
}
